// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"277":"cb288eaa","787":"cc70c354","836":"24534bd1"}[chunkId] + ".chunk.js";
};